import React, { useContext } from "react";
import "./RequestsForFlow.css";
import {RequestSearchResults} from "./RequestSearchResults";
import useSWR from "swr";
import StructuredLogContext from "../../providers/structuredLog-context";
import { parseDate } from "../shared/DateTimeFormat";
import { DateTime } from 'luxon';

const findMostRecentTimestampInLastData = (lastData) => {
    let lastDate = undefined;
    if (lastData && lastData.data) {
        for (const request of lastData.data.listRequestsDynamicSearch.items) {
            if (request.timestamp) {
              const requestTimestamp = parseDate(request.timestamp);
              if (lastDate) {
                if (lastDate < requestTimestamp) {
                    lastDate = requestTimestamp;
                }
              } else {
                lastDate = requestTimestamp;
              }
            }
        }
    }
    return lastDate;
}

const useRequestsForFlow = (flowId, flowFinal) => {
    const structuredLogsService = useContext(StructuredLogContext);

    const options = {};
    if (flowFinal) {
        options.refreshInterval = (lastData) => {
            const mostRecentTimestamp = findMostRecentTimestampInLastData(lastData);
            const now = DateTime.now();
            if (mostRecentTimestamp && mostRecentTimestamp.plus({ minutes: 15 }) < now) {
                //Is not a recent flow, lets refresh but not that often
                return 60 * 1000;
            } else {
                return 5 * 1000;
            }
        }
    } else {
        options.refreshInterval = 5 * 1000;
    }

    const fetcher = async (flowId) => await structuredLogsService.listRequestForFlow(flowId);
    return useSWR(flowId, fetcher, options);
}

function RequestsForFlow({flow}) {

    const { data, error, isLoading } = useRequestsForFlow(flow.id, flow.final); 

    const searchResults = data && data.data ? data.data.listRequestsDynamicSearch.items : [];

    console.log("Requests for flow results: ", data, error, isLoading);


    return (
        <div className="flowDetail">
            <RequestSearchResults searchResults={searchResults} loading={isLoading} />
        </div>
    )
}

export {RequestsForFlow};